module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/226-united-states-a4482e8de9e2ecc7e2fa9ca2efc1a286.svg";